import { apiGet, apiPost, apiDelete, apiPut } from "../../api/apiClient";

const ADMIN_CANDIDATES_BASE = "/api/admin/candidates";
const ADMIN_EMPLOYE_BASE = "/api/admin/employees";

// -------- GET all candidates --------
export const fetchCandidates = () =>
  apiGet(`${ADMIN_CANDIDATES_BASE}/list`);

// -------- DEACTIVATE candidate --------
export function deactivateCandidate(candidateId) {
  return apiDelete(`${ADMIN_CANDIDATES_BASE}/${candidateId}`);
}

// -------- REACTIVATE candidate --------
export function reactivateCandidate(candidateId) {
  return apiPost(`${ADMIN_CANDIDATES_BASE}/${candidateId}/reactivate`, {});
}

// -------- CREATE candidate (for later) --------
export const createCandidate = (payload) =>{
  return apiPost(ADMIN_CANDIDATES_BASE, payload);
}

// -------- UPDATE candidate (for later) --------
export function updateCandidate(candidateId, payload) {
  return apiPut(`${ADMIN_CANDIDATES_BASE}/${candidateId}`, payload);
}


/**
 * Employee options for assignment
 */
export const fetchEmployeeOptions = () => {
    return apiGet(`${ADMIN_EMPLOYE_BASE}/options`);
};

export const fetchCandidateById = (id) =>
  apiGet(`${ADMIN_CANDIDATES_BASE}/${id}`);
